// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Experiences_pagination__1OcX9","active":"Experiences_active__1X7zc"};